import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '分类导航',
    links: [
      { to: '/category/grading-system', label: '分级制度' },
      { to: '/category/history', label: '历史演变' },
      { to: '/category/representative-works', label: '代表作品' },
    ],
  },
  {
    title: '研究领域',
    links: [
      { to: '/category/cultural-studies', label: '文化研究' },
      { to: '/category/censorship', label: '审查制度' },
      { to: '/category/asian-classification', label: '亚洲电影分级' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/about#reputation', label: '学术声誉' },
      { to: '/about#contact', label: '联系我们' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 text-foreground-950 font-semibold text-lg mb-4 whitespace-nowrap cursor-pointer">
              <i className="ri-film-line text-2xl text-primary-500"></i>
              <span>电影分级研究</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              致力于系统梳理香港及亚洲电影分级制度的历史、文化与学术价值，为电影研究者和爱好者提供权威知识平台。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">{group.title}</h4>
              <ul className="space-y-2">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 电影分级研究. 本站内容仅供学术研究与文化交流之用.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}